import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hero-banner',
  templateUrl: './hero-banner.component.html',
  styleUrls: ['./hero-banner.component.scss'],
  standalone: false
})
export class HeroBannerComponent {
  @Input()
  image: string;

  @Input()
  imageHeight = '300px';

  getBackgroundImageSource() {
    return {
      mobile: `/hero-banner/${this.image}-mobile.jpg`,
      tablette: `/hero-banner/${this.image}-tablet.jpg`,
      desktop: `/hero-banner/${this.image}-desktop.jpg`
    };
  }
}
